"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxDocumentBuilder = void 0;
var TxRelatedId_1 = require("../common/TxRelatedId");
var TxDocumentBuilder = /** @class */ (function () {
    function TxDocumentBuilder() {
    }
    TxDocumentBuilder.build = function (tx, block, confirmed, chainId) {
        var chain = Number(chainId);
        return {
            id: TxRelatedId_1.TxRelatedId.create(chain, tx.hash),
            hash: tx.hash,
            chainId: chain,
            transactionIndex: parseInt(tx.transactionIndex, 10),
            gas: parseInt(tx.gas, 10),
            gasPrice: parseInt(tx.gasPrice, 10),
            nonce: parseInt(tx.nonce, 10),
            fromAddress: tx.fromAddress,
            toAddress: tx.toAddress,
            value: tx.value || '0',
            input: tx.input,
            type: parseInt(tx.type, 10),
            receiptStatus: parseInt(tx.receiptStatus, 10),
            receiptGasUsed: parseInt(tx.receiptGasUsed, 10),
            receiptCumulativeGasUsed: parseInt(tx.receiptCumulativeGasUsed, 10),
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
        };
    };
    return TxDocumentBuilder;
}());
exports.TxDocumentBuilder = TxDocumentBuilder;
//# sourceMappingURL=TxDocumentBuilder.js.map